import React from 'react'
import { Logo } from 'assets'
import { Img, WrapImg } from 'styles/GlobalStyle'
import { SvgIcon } from '@mui/material'
import { ReactComponent as LogoIcon } from 'assets/Logo.svg';


const CustomLogo = (props) => {
    const { width = 170, height = 170, action } = props

    return (
        <WrapImg width={width} height={height} onClick={() => action && action()}>
            <SvgIcon fontSize="small" component={LogoIcon} color="black" inheritViewBox />
        </WrapImg>
    )
}

export default CustomLogo